import { render, staticRenderFns } from "./ObjectEmbed.vue?vue&type=template&id=6f89deb5&"
import script from "./ObjectEmbed.vue?vue&type=script&lang=js&"
export * from "./ObjectEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports